<div class="d-flex flex-column">
	<div style="max-width: 1300px">
		<div
			class="header-relatorio d-flex my-3 flex-column flex-md-row justify-content-end align-items-center gap-2">
			<label
				class="titulo-relatorio text-tertiary fw-semibold text-center mb-0 order-2 order-md-1">
				{{ tituloRelatorio }}
			</label>
			<div
				class="d-flex flex-row justify-content-end align-items-center gap-2 order-1 order-md-2 flex-shrink-0 w-100 w-md-auto">
				<button
					type="button"
					class="btn btn-primary d-flex align-items-center gap-2 ml-2"
					style="height: 40px"
					[disabled]="carregando"
					(click)="alternarExibicaoEstatisticas()">
					<i
						class="ph"
						[ngClass]="exibirEstatisticas ? 'ph-eye-slash' : 'ph-eye'"></i>
					<span style="font-size: 14px">{{
						exibirEstatisticas ? 'Ocultar estatísticas' : 'Mostrar estatísticas'
					}}</span>
				</button>
				<seira-select-list-menu
					[opcoes]="opcoesColunas"
					[opcoesSelecionadas]="colunasSelecionadas"
					[disabled]="carregando"
					[tituloBotao]="'Personalizar colunas'"
					(atualizarOpcoesSelecionadas)="setColunasSelecionadas($event)">
				</seira-select-list-menu>
			</div>
		</div>

		<div
			*ngIf="carregando; else tabela"
			class="d-flex justify-content-center align-items-center w-100 h-50"
			style="min-height: 500px">
			<seira-loading [pageCentered]="false"></seira-loading>
		</div>

		<ng-template #tabela>
			<div
				style="max-width: 1300px"
				*ngIf="relatorio.length; else nenhumResultado">
				<seira-tabela-relatorio-pluv-mensal-personalizada
					[precipitacaoMensal]="relatorio"
					[estatisticas]="estatisticas"
					[colunasSelecionadas]="colunasSelecionadas"
					[exibirEstatisticas]="exibirEstatisticas" />
			</div>
		</ng-template>

		<seira-card-info aditionalClasses="mt-2" [texto]="descricaoRelatorio" />

		<ng-template #nenhumResultado>
			<seira-sem-dados></seira-sem-dados>
		</ng-template>
	</div>
</div>
